<template>
  <div class="terms">
    <br /><br />
    <v-container>
      <v-layout wrap>
        <v-flex mb-5 xs12 md8 offset-md2>
          <br />
          <!-- <v-flex justify-center mb-2 mt-5 xs12>
            <h1>About PerfectStaff</h1>
          </v-flex> -->
          <br /><br />
          <h1>Terms & Conditions</h1>
          <br />
          <p>
            <strong id="subHeading">CONDITIONS OF USE</strong>
          </p>
          <p>
            Welcome to our Perfect Staff!
            <strong>Perfect Staff</strong> and its associates provide their
            services to you subject to the following conditions. If you visit or
            shop within this website, you accept these conditions. Please read
            them carefully.
          </p>
          <p>
            <strong id="subHeading">PRIVACY</strong>
          </p>
          <p>
            Please review our Privacy Notice, which also governs your visit to
            our website, to understand our practices.
          </p>
          <p>
            <strong id="subHeading">ELECTRONIC COMMUNICATIONS</strong>
          </p>
          <p>
            When you visit
            <strong>Perfect Staff</strong> or send e-mails to us, you are
            communicating with us electronically. You consent to receive
            communications from us electronically. We will communicate with you
            by e-mail or by posting notices on this site. You agree that all
            agreements, notices, disclosures and other communications that we
            provide to you electronically satisfy any legal requirement that
            such communications be in writing.
          </p>
          <p>
            <strong id="subHeading">COPYRIGHT</strong>
          </p>
          <p>
            All content included on this site, such as text, graphics, logos,
            button icons, images, audio clips, digital downloads, data
            compilations, and software, is the property of
            <strong>Perfect Staff</strong> or its content suppliers and
            protected by international copyright laws. The compilation of all
            content on this site is the exclusive property of
            <strong>Perfect Staff</strong>, with copyright authorship for this
            collection by <strong>Perfect Staff</strong>, and protected by
            international copyright laws.
          </p>
          <p>
            <strong id="subHeading">TRADE MARKS</strong>
          </p>
          <p>
            <strong>Perfect Staff's</strong> trademarks and trade dress may not
            be used in connection with any product or service that is not
            <strong>Perfect Staff's</strong>, in any manner that is likely to
            cause confusion among customers, or in any manner that disparages or
            discredits <strong>Perfect Staff</strong>. All other trademarks not
            owned by <strong>Perfect Staff</strong> or its subsidiaries that
            appear on this site are the property of their respective owners, who
            may or may not be affiliated with, connected to, or sponsored by
            <strong>Perfect Staff</strong> or its subsidiaries.
          </p>
          <p>
            <strong id="subHeading">LICENSE AND SITE ACCESS</strong>
          </p>
          <p>
            <strong>Perfect Staff</strong> grants you a limited license to
            access and make personal use of this site and not to download (other
            than page caching) or modify it, or any portion of it, except with
            express written consent of <strong>Perfect Staff</strong>. This
            license does not include any resale or commercial use of this site
            or its contents: any collection and use of any product listings,
            descriptions, or prices: any derivative use of this site or its
            contents: any downloading or copying of account information for the
            benefit of another merchant: or any use of data mining, robots, or
            similar data gathering and extraction tools. This site or any
            portion of this site may not be reproduced, duplicated, copied,
            sold, resold, visited, or otherwise exploited for any commercial
            purpose without express written consent of
            <strong>Perfect Staff</strong>. You may not frame or utilize framing
            techniques to enclose any trademark, logo, or other proprietary
            information (including images, text, page layout, or form) of
            <strong>Perfect Staff</strong> and our associates without express
            written consent. You may not use any meta tags or any other "hidden
            text" utilizing <strong>Perfect Staff's</strong> name or trademarks
            without the express written consent of
            <strong>Perfect Staff</strong>. Any unauthorized use terminates the
            permission or license granted by <strong>Perfect Staff</strong>. You
            are granted a limited, revocable, and nonexclusive right to create a
            hyperlink to the home page of <strong>Perfect Staff</strong> so long
            as the link does not portray <strong>Perfect Staff</strong>, its
            associates, or their products or services in a false, misleading,
            derogatory, or otherwise offensive matter. You may not use any
            <strong>Perfect Staff</strong> logo or other proprietary graphic or
            trademark as part of the link without express written permission.
          </p>
          <p>
            <strong id="subHeading">YOUR MEMBERSHIP ACCOUNT</strong>
          </p>
          <p>
            If you use this site, you are responsible for maintaining the
            confidentiality of your account and password and for restricting
            access to your computer, and you agree to accept responsibility for
            all activities that occur under your account or password. If you are
            under 18, you may use our website only with involvement of a parent
            or guardian. <strong>Perfect Staff</strong> and its associates
            reserve the right to refuse service, terminate accounts, remove or
            edit content, or cancel orders in their sole discretion.
          </p>
          <p>
            <strong id="subHeading"
              >REVIEWS, COMMENTS, EMAILS, AND OTHER CONTENT</strong
            >
          </p>
          <p>
            Visitors may post reviews, comments, and other content: and submit
            suggestions, ideas, comments, questions, or other information, so
            long as the content is not illegal, obscene, threatening,
            defamatory, invasive of privacy, infringing of intellectual property
            rights, or otherwise injurious to third parties or objectionable and
            does not consist of or contain software viruses, political
            campaigning, commercial solicitation, chain letters, mass mailings,
            or any form of "spam." You may not use a false e-mail address,
            impersonate any person or entity, or otherwise mislead as to the
            origin of a card or other content.
            <strong>Perfect Staff</strong> reserves the right (but not the
            obligation) to remove or edit such content, but does not regularly
            review posted content. If you do post content or submit material,
            and unless we indicate otherwise, you grant
            <strong>Perfect Staff</strong> and its associates a nonexclusive,
            royalty-free, perpetual, irrevocable, and fully sublicensable right
            to use, reproduce, modify, adapt, publish, translate, create
            derivative works from, distribute, and display such content
            throughout the world in any media. You grant
            <strong>Perfect Staff</strong> and its associates and sublicensees
            the right to use the name that you submit in connection with such
            content, if they choose. You represent and warrant that you own or
            otherwise control all of the rights to the content that you post:
            that the content is accurate: that use of the content you supply
            does not violate this policy and will not cause injury to any person
            or entity: and that you will indemnify
            <strong>Perfect Staff</strong> or its associates for all claims
            resulting from content you supply.
            <strong>Perfect Staff</strong> has the right but not the obligation
            to monitor and edit or remove any activity or content.
            <strong>Perfect Staff</strong> takes no responsibility and assumes
            no liability for any content posted by you or any third party.
          </p>
          <p>
            <strong id="subHeading">PRODUCT DESCRIPTIONS</strong>
          </p>
          <p>
            <strong>Perfect Staff</strong> and its associates attempt to be as
            accurate as possible. However, <strong>Perfect Staff</strong> does
            not warrant that product descriptions or other content of this site
            is accurate, complete, reliable, current, or error-free. If a
            product offered by <strong>Perfect Staff</strong> itself is not as
            described, your sole remedy is to make contact with us and together
            we can attempt to resolve the situation..
          </p>

          <p>
            <strong>
              DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY THIS SITE IS
              PROVIDED BY <strong>Perfect Staff</strong> ON AN "AS IS" AND "AS
              AVAILABLE" BASIS. <strong>Perfect Staff</strong> MAKES NO
              REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS
              TO THE OPERATION OF THIS SITE OR THE INFORMATION, CONTENT,
              MATERIALS, OR PRODUCTS INCLUDED ON THIS SITE. YOU EXPRESSLY AGREE
              THAT YOUR USE OF THIS SITE IS AT YOUR SOLE RISK. TO THE FULL
              EXTENT PERMISSIBLE BY APPLICABLE LAW,
              <strong>Perfect Staff</strong> DISCLAIMS ALL WARRANTIES, EXPRESS
              OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
              <strong>Perfect Staff</strong> DOES NOT WARRANT THAT THIS SITE,
              ITS SERVERS, OR E-MAIL SENT FROM
              <strong>Perfect Staff</strong> ARE FREE OF VIRUSES OR OTHER
              HARMFUL COMPONENTS.<strong>Perfect Staff</strong> WILL NOT BE
              LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS
              SITE, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL,
              PUNITIVE, AND CONSEQUENTIAL DAMAGES. CERTAIN STATE LAWS DO NOT
              ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR
              LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR
              ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT
              APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS. APPLICABLE LAW
            </strong>
          </p>
          <p>
            By visiting
            <strong>Perfect Staff</strong>, you agree that the laws of South
            Africa, without regard to principles of conflict of laws, will
            govern these Conditions of Use and any dispute of any sort that
            might arise between you and <strong>Perfect Staff</strong> or its
            associates.
          </p>
          <p>
            <strong id="subHeading">DISPUTES</strong>
          </p>
          <p>
            Any dispute relating in any way to your visit to
            <strong>Perfect Staff</strong> or to products you purchase through
            <strong>Perfect Staff</strong> shall be submitted to confidential
            arbitration in South Africa, except that, to the extent you have in
            any manner violated or threatened to violate
            <strong>Perfect Staff's</strong> intellectual property rights,
            <strong>Perfect Staff</strong> may seek injunctive or other
            appropriate relief in any court in South Africa, and you consent to
            exclusive jurisdiction and venue in such courts. Arbitration under
            this agreement shall be conducted under the rules then prevailing of
            the American Arbitration Association. The arbitrators award shall be
            binding and may be entered as a judgment in any court of competent
            jurisdiction. To the fullest extent permitted by applicable law, no
            arbitration under this Agreement shall be joined to an arbitratio
            involving any other party subject to this Agreement, whether through
            class arbitration proceedings or otherwise.
          </p>
          <p>
            <strong id="subHeading"
              >SITE POLICIES, MODIFICATION, AND SEVERABILITY</strong
            >
          </p>
          <p>
            Please review our other policies, such as our Shipping and Returns
            policy, posted on this site. These policies also govern your visit
            to
            <strong>Perfect Staff</strong>.We reserve the right to make changes
            to our site, policies, and these Conditions of Use at any time. If
            any of these conditions shall be deemed invalid, void, or for any
            reason unenforceable, that condition shall be deemed severable and
            shall not affect the validity and enforceability of any remaining
            condition.
          </p>
          <p>
            <strong id="subHeading">QUESTIONS:</strong>
          </p>
          <p>
            Questions regarding our Conditions of Usage, Privacy Policy, or
            other policy related material can be directed to our support staff
            by clicking on the "Contact Us" link in the side menu. Or you can
            email us
            <a href="mailto:support@perfect-staff.com">email</a>
          </p>
          <v-btn dark color="#010a43" @click="back">Return</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "terms",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
#subHeading {
  color: #010a43;
  text-decoration-line: underline;
}
a {
  text-decoration: none;
  color: black;
}
h1 {
  color: #010a43;
}
</style>
